import { createFileRoute } from "@tanstack/react-router";
import { OrgNewContainer } from "@/features/organisation/containers/org-new-container";

export const Route = createFileRoute("/app/settings/organisation/new")({
  component: OrgNewContainer,
});
